import React from 'react';
import ReportSectionPage from '../../../common/components/reports/ReportSectionPage';

const SurveyReport = () => {
  return <ReportSectionPage scope="super-admin" section="surveys" title="Survey Report" />;
};

export default SurveyReport;
